// Exchange the one-use signup credential on the dashboard origin so Django's
// session cookie belongs to the dashboard. Keep it out of URLs and history.
export function submitCustomerSignupHandoff() {
    const code = new URLSearchParams(window.location.hash.slice(1)).get("handoff_code");
    if (!code) return false;
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/api/account/profile-update-handoff/";
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "handoff_code";
    input.value = code;
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    return true;
}
